// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.sinusoidal-function[data-v-0b17a98a] {\r\n    background-color: #f0f0f0;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    text-align: center;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
